import React from 'react';
// import { useQuery, gql } from '@apollo/client';
import { Typography, Paper } from '@material-ui/core';
import Paragraph from './Paragraph';

function Chapter({ chapterData }) {
  // console.log('Chapter data ', chapterData);
  return (
    <div dir={chapterData && chapterData.textDirection}>
      <Paper key="BiblePage">
        {/* <div align="right">
          {chapterData &&
            chapterData.audioUrl &&
            chapterData.audioUrl !== null && (
              <audio src={chapterData && chapterData.audioUrl} controls type="audio/mpeg" />
            )}
        </div> */}
        <Typography variant="h3" key="bookTitle">
          {chapterData && chapterData.title}
        </Typography>
        <p />
        <Typography variant="h4" key="chapterNumber">
          {chapterData && chapterData.wordForChapter}
        </Typography>
        <p />
        {chapterData &&
          chapterData.paragraph.map(currentPara => (
            <Paragraph paragraph={currentPara} key={currentPara && currentPara.id} />
          ))}
      </Paper>
    </div>
  );
}
export default Chapter;
